<template>
  <h2
    v-if="relatedLessons.length"
    class="text-4xl font-semibold"
  >
    Related Learning:
  </h2>

  <ul
    v-if="relatedLessons.length"
    class="grid grid-cols-1 lg:grid-cols-2 gap-8"
  >
    <li
      v-for="lesson in relatedLessons"
      :key="lesson.uuid"
    >
      <LessonCard :lesson="lesson" />
    </li>
  </ul>
</template>
<script lang="ts">
export default { name: 'RelatedLessons' }
</script>
<script setup lang="ts">
import { onBeforeMount, ref } from 'vue'

import GarbanzoApi from '~/services/garbanzo-api/GarbanzoApi'
import { getObjects } from '~/lib/algoliaHelper'

import { useConfigStore } from '~/store/config'

import { LessonRecord } from '~/types/records/LessonRecord'
import { AlgoliaRecord } from '~/types/records/AlgoliaRecord'
import { RecordType } from '~/types/records/RecordType'
import { ApiCollection } from '~/types/records/ApiCollection'

import LessonCard from './LessonCard.vue'

const props = defineProps<{
  uuid: string,
}>()

const relatedLessons = ref<LessonRecord[]>([])

onBeforeMount(async () => {
  const client = new GarbanzoApi(useConfigStore().config.API_BASE_URL)

  // get related lessons from API
  const apiResponse = await client.getRelatedLessons(props.uuid) as ApiCollection<LessonRecord>

  // expand related lessons with Algolia data
  const apiLessons = Object.values(apiResponse)
  const uuids = apiLessons.map(r => r.uuid)
  const algoliaLessons = await getObjects(RecordType.Lesson, uuids) as AlgoliaRecord[]

  relatedLessons.value = uuids.map(uuid => ({
    ...algoliaLessons.find(record => uuid === record.uuid),
    ...apiLessons.find(record => uuid === record.uuid),
  }))
})

</script>
